var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.1C6.50294 5.1 6.1 5.50294 6.1 6V20.7093L6.1002 20.7282C6.21781 26.3479 7.97284 31.8112 11.1501 36.4481C14.3273 41.085 18.7886 44.6939 23.9869 46.8323C24.2062 46.9225 24.4522 46.9226 24.6715 46.8324C29.8711 44.6949 34.3339 41.0864 37.5126 36.4495C40.6913 31.8127 42.4477 26.3489 42.5665 20.7283L42.5667 20.7093V6C42.5667 5.50294 42.1637 5.1 41.6667 5.1H7Z",
    fill: "#DCEFF9",
    stroke: "#0045A4",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6667 20.7093V6H24.3333L24.3293 46C29.3669 43.9291 33.6907 40.4331 36.7703 35.9407C39.85 31.4483 41.5516 26.1548 41.6667 20.7093Z",
    fill: "#0045A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.d2645a64.svg";
export { ForwardRef as ReactComponent };